import { FC, useMemo, useCallback } from 'react';

import { useInternalScrollCarousel } from '../helpers/InternalScrollCarouselContext';
import { ScrollCarouselDotProvider } from '../helpers/ScrollCarouselDotContext';

import styles from './Dots.scss';

const Dot: FC<{ index: number }> = ({ index }) => {
    const { DotComponent, stepSize, backfill, currentIndex, setCurrentIndex } =
        useInternalScrollCarousel();

    const dotIndex = backfill.startCount + index * stepSize;

    const setActive = useCallback(() => {
        setCurrentIndex(dotIndex);
    }, [setCurrentIndex, dotIndex]);

    const contextValue = useMemo(
        () => ({
            isActive: dotIndex === currentIndex,
            setActive,
            activeSlide: index + 1,
        }),
        [dotIndex, currentIndex, setActive, index]
    );

    return DotComponent ? (
        <ScrollCarouselDotProvider value={contextValue}>
            <DotComponent />
        </ScrollCarouselDotProvider>
    ) : null;
};

export const Dots: FC = () => {
    const { showDots, totalItems, stepSize } = useInternalScrollCarousel();

    if (!showDots) {
        return null;
    }

    const totalDots = Math.ceil(totalItems / stepSize);

    return (
        <div className={styles.dotsWrapper}>
            {Array(totalDots)
                .fill(0)
                .map((_, index) => (
                    <Dot key={index} index={index} />
                ))}
        </div>
    );
};
